module.exports = __webpack_public_path__ + "static/media/8.fe2f1ab9.jpeg";